import superagent, { SuperAgentRequest, Response } from "superagent";
import { faro } from "@grafana/faro-web-sdk";
import { logout } from "./LogoutUtil";

const request = superagent.agent()
  .use(function (req: SuperAgentRequest) {
    req.on('response', function (res: Response) {
      if (!res.ok) {
        // Report server errors (5xx) to Faro for monitoring
        // We skip 4xx errors as they are typically expected application behavior:
        // - 400: Validation errors (user input)
        // - 401: Session timeout (normal lifecycle)
        // - 403: Permission denied (access control)
        // - 404: Not found (expected for invalid routes)
        // Note: Faro may be disabled via LaunchDarkly flag, so we wrap in try/catch
        if (res?.status >= 500) {
          try {
            if (faro?.api) {
              const url = req.url || 'unknown';
              const method = req.method || 'unknown';
              faro.api.pushError(
                new Error(`HTTP ${res.status}: Server error on ${method} ${url}`),
                {
                  context: {
                    url,
                    method,
                    status: String(res.status),
                    statusText: res.text?.substring(0, 200) || '',
                  },
                }
              );
            }
          } catch {
            // Faro not initialized (disabled via LaunchDarkly) - silently ignore
          }
        }

        if (res?.status === 401) {
          // Only redirect to logout if not already on logout or login pages
          // This prevents infinite redirect loops when polling /api/authority
          const currentPath = window.location.pathname;
          if (currentPath !== '/logout' && currentPath !== '/login' && currentPath !== '/verify') {
            logout();
          }
        }
      }
    });
  });

export default request;

/**
 * Public request agent — shared Faro 5xx reporting but NO 401 logout redirect.
 * Use for public endpoints or authenticated requests whose caller handles session expiry
 * (such as authority/session polling). Authentication cookies still accompany same-origin requests;
 * use the default request agent when a 401 should trigger the global logout flow.
 */
export const publicRequest = superagent.agent()
  .use(function (req: SuperAgentRequest) {
    req.on('response', function (res: Response) {
      if (!res.ok && res?.status >= 500 && req.url !== '/api/account/verification-email/verify') {
        try {
          if (faro?.api) {
            const url = req.url || 'unknown';
            const method = req.method || 'unknown';
            faro.api.pushError(
              new Error(`HTTP ${res.status}: Server error on ${method} ${url}`),
              {
                context: {
                  url,
                  method,
                  status: String(res.status),
                  statusText: res.text?.substring(0, 200) || '',
                },
              }
            );
          }
        } catch {
          // Faro not initialized — silently ignore
        }
      }
    });
  });
